import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { MessagesTradeField } from '~/models/classified/messages-trade'
import { toCamelCase } from '~/utils/object'

@containerScoped()
export default class MessagesTradeService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  public fetchMessagesTradeForm(
    classifiedId: number,
    make?: number
  ): Promise<Array<MessagesTradeField>> {
    return this.requestBuilder
      .request('get', `/api/classifieds/${classifiedId}/messages/trade`)
      .params({ make })
      .validate(body => body && body.data)
      .map(body => toCamelCase(body.data))
      .send()
  }
}
